import _assert_this_initialized from "@swc/helpers/src/_assert_this_initialized.mjs";
import _class_call_check from "@swc/helpers/src/_class_call_check.mjs";
import _create_class from "@swc/helpers/src/_create_class.mjs";
import _inherits from "@swc/helpers/src/_inherits.mjs";
import _create_super from "@swc/helpers/src/_create_super.mjs";
import IconButton from "@material-ui/core/IconButton";
import MuiSnackbar from "@material-ui/core/Snackbar";
import { createStyles, withStyles } from "@material-ui/core/styles";
import Close from "@material-ui/icons/Close";
import Error from "@material-ui/icons/Error";
import Info from "@material-ui/icons/Info";
import Warning from "@material-ui/icons/Warning";
import capitalize from "lodash/capitalize";
import * as React from "react";
import { SnackbarContext } from "./contexts/snackbar";
var icons = {
    Info: Info,
    Warning: Warning,
    Error: Error
};
var styles = function(theme) {
    return createStyles({
        closeSnackbar: {
            width: theme.spacing(4)
        },
        snackbar: {
            marginTop: "4em"
        },
        snackContainer: {
            display: "inline-block"
        },
        snackMessage: {
            display: "inline-block",
            marginLeft: "10px",
            verticalAlign: "middle"
        },
        errorIcon: {
            color: "#ff6251",
            verticalAlign: "middle"
        },
        infoIcon: {
            color: "#75beff",
            verticalAlign: "middle"
        }
    });
};
var Snackbar = /*#__PURE__*/ function(_Component) {
    "use strict";
    _inherits(Snackbar, _Component);
    var _super = _create_super(Snackbar);
    function Snackbar() {
        _class_call_check(this, Snackbar);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.queue = [];
        _this.state = {
            open: false,
            context: {
                spawn: _this.spawn.bind(_assert_this_initialized(_this))
            },
            onClose: function() {
                return undefined;
            }
        };
        _this.processQueue = function(onClose) {
            if (_this.queue.length > 0) {
                _this.setState({
                    message: _this.queue.shift(),
                    open: true,
                    onClose: onClose
                });
            }
        };
        _this.handleClose = function(_event) {
            var reason = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
            _this.state.onClose();
            if (reason === "clickaway") {
                return;
            }
            _this.setState({
                open: false
            });
        };
        _this.handleExited = function() {
            _this.processQueue(_this.state.onClose);
        };
        return _this;
    }
    _create_class(Snackbar, [
        {
            key: "spawn",
            value: function spawn(message) {
                var level = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "info", onClose = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : function() {
                    return undefined;
                };
                this.queue.push({
                    key: Date.now(),
                    content: message,
                    level: level
                });
                this.processQueue(onClose);
            }
        },
        {
            key: "render",
            value: function render() {
                var _state = this.state, message = _state.message, open = _state.open, context = _state.context;
                var _props = this.props, classes = _props.classes, children = _props.children;
                var level = message && message.level || "info";
                var Icon = icons[capitalize(level)];
                var messageContent = /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Icon, {
                    className: classes["".concat(level, "Icon")]
                }), /*#__PURE__*/ React.createElement("span", {
                    className: classes.snackMessage
                }, message && message.content || ""));
                var action = /*#__PURE__*/ React.createElement(IconButton, {
                    key: "close",
                    "aria-label": "Close",
                    color: "inherit",
                    className: classes.closeSnackbar,
                    onClick: this.handleClose
                }, /*#__PURE__*/ React.createElement(Close, null));
                return /*#__PURE__*/ React.createElement(SnackbarContext.Provider, {
                    value: context
                }, children, open ? /*#__PURE__*/ React.createElement(MuiSnackbar, {
                    anchorOrigin: {
                        vertical: "top",
                        horizontal: "right"
                    },
                    open: open,
                    autoHideDuration: 6000,
                    onClose: this.handleClose,
                    TransitionProps: {
                        onExited: this.handleExited
                    },
                    className: classes.snackbar,
                    message: messageContent,
                    action: action
                }) : null);
            }
        }
    ]);
    return Snackbar;
}(React.Component);
export default withStyles(styles)(Snackbar);
